import * as ravenMiddleware from 'redux-raven-middleware';

import { History } from 'history';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore, Middleware } from 'redux';
import { default as thunk } from 'redux-thunk';

import { Config } from 'models/config';
import { appReducer } from 'reducers/app';

let store = createStore(appReducer);

export function configureStore(config: Config, history: History) {
  const middlewares: Middleware[] = [routerMiddleware(history), thunk];

  if (config.sentryDsn) {
    middlewares.push(ravenMiddleware(config.sentryDsn));
  }

  // Enable Redux Chrome Devtool on development
  const composeEnhancers: <R>(a: R) => R = ((
      config.env === 'development' || config.env === 'devProduction' || config.env === 'devStaging' || config.env === 'playground'
    )
    && typeof window === 'object'
    && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    || compose;

  return store = createStore(appReducer, composeEnhancers(
    applyMiddleware(...middlewares)
  ));
}

export { store };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/store.ts